import {
  Box,
  Button,
  Typography
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import React from 'react';
import { VoterGroup } from '../../types';
import VoterGroupListControl from './VoterGroupListControl';
import useAuth from '../../hooks/useAuth';

interface VoterGroupListProps {
}

const VoterGroupList: React.FC<VoterGroupListProps> = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const onVoterGroupEdit = async (voterGroup: VoterGroup) => {
    navigate(`/voter-groups/edit/${voterGroup.id}`);
  };

  const onVoterGroupDelete = async (voterGroup: VoterGroup) => {
    // Optional: Add any additional logic for deletion notification
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Voters Group</Typography>
        {user?.permissions?.manage_voter_groups && (
          <Box>
            <Button component={Link} to="/voter-groups/new" variant="contained" color="primary">
              New Voter Group
            </Button>
          </Box>
        )}
      </Box>
      <VoterGroupListControl onEdit={onVoterGroupEdit} onDelete={onVoterGroupDelete} />
    </Box>
  );
}

export default VoterGroupList;
